import { Navigate } from "react-router-dom"
import Home from "../pages/Home"

function requireAuth(){
    if(!localStorage.access_token || localStorage.getItem('access_token')==undefined){
        return <Navigate to="/login" />
    }

    return <Home />
}

export default requireAuth